import React, { useState } from "react";
// import renderHtml from "react-render-html";
import { renderHtml } from "../components/RenderHtml";
import Moment from "react-moment";
import InternalError from "../components/InternalError";
import uploadLog from "../modules/uploadLog";
import { config } from "../config/config";
import "../css/notice.css";
import {
  Container,
  ContentsWrapper,
  ImageWrapper,
  TextWrapper,
  Title,
  Description,
  Date,
} from "../components/Detail";

const NoticeDetail = (props) => {
  const [error, setError] = useState();

  const _setContents = () => {
    try {
      const notices = props;
      const language = props.language;

      if (notices.files && notices.files[0] && notices.files[0].src) {
        return (
          <>
            <TextWrapper
              className={
                config.SPACE_FREE.indexOf(language) !== -1 ? "isBreakAll" : ""
              }
              dir={config.ARAB.indexOf(language) !== -1 ? "rtl" : ""}
            >
              <Title>
                {notices.subtitle !== "" ? notices.subtitle : notices.title}
              </Title>
              <Date>
                <Moment format="MMM DD, YYYY">
                  {notices.createdAt
                    ? notices.createdAt
                    : notices.publishedAt}
                </Moment>
              </Date>
              <ImageWrapper>
                <img
                  style={{ width: "100%", border: "solid" }}
                  src={notices.files[0].src}
                  alt={notices.files[0].title}
                />
              </ImageWrapper>
              <Description>
                <div style={{ marginLeft: 0 }}>
                  {renderHtml(notices.description)}
                </div>
              </Description>
            </TextWrapper>
          </>
        );
      } else {
        return (
          <>
            <TextWrapper
              className={
                config.SPACE_FREE.indexOf(language) !== -1 ? "isBreakAll" : ""
              }
              style={{ width: "100vw" }}
              dir={config.ARAB.indexOf(language) !== -1 ? "rtl" : ""}
            >
              <Title>
                {notices.subtitle !== "" ? notices.subtitle : notices.title}
              </Title>
              <Date>
                <Moment format="MMM DD, YYYY">
                  {notices.createdAt
                    ? notices.createdAt
                    : notices.publishedAt}
                </Moment>
              </Date>
              <Description>
                <div style={{ marginLeft: 0 }}>
                  {renderHtml(notices.description)}
                </div>
              </Description>
            </TextWrapper>
          </>
        );
      }
    } catch (err) {
      setError(err.message);
    }
  };

  if (error) {
    uploadLog(window.location.href, "ERROR", error);
    return (
      <Container>
        <InternalError />
      </Container>
    );
  }

  return (
    <>
      <Container>
        <ContentsWrapper>{_setContents()}</ContentsWrapper>
      </Container>
    </>
  );
};

export default NoticeDetail;
